import { atom, createStore } from "jotai";
import { atomWithStorage } from 'jotai/utils'
export const store = createStore();

export const accountAtom = atomWithStorage<any>('account', null);
export const accountsAtom = atomWithStorage<any>('accounts', null);
export const previousAtom = atomWithStorage<any>('previous', null);


